import styled from 'styled-components';
import { margin, media, padding } from '../../theme';
import { Button as ButtonComponent } from '../button';
export const Pagination = styled.nav `
  display: flex;
  ${media.down('sm') `
    margin: 1rem auto 0;
  `}
`;
export const Button = styled(ButtonComponent) `
  && {
    height: ${(props) => props.theme.buttons.buttonHeight};
    border-color: ${(props) => props.theme.colors.grayL20};
    width: auto;
    /* We want the buttons to be square, so it's safe to use the height here. */
    min-width: ${(props) => props.theme.buttons.buttonHeight};

    line-height: 1rem;
    ${padding.horizontal('small')}

    &.active {
      background-color: ${(props) => props.theme.colors.grayD40};
      border-color: ${(props) => props.theme.colors.grayD40};
      color: ${(props) => props.theme.colors.white};
    }

    /* The disabled state of pagination buttons are a little bit different than normal buttons */
    &:disabled:not(.active) {
      background-color: ${(props) => props.theme.colors.white};
      border-color: ${(props) => props.theme.colors.grayL30};
      color: ${(props) => props.theme.colors.grayL20};
    }

    /**
     * Wrap the hover state in a media query to prevent sticky hovers on mobile. We can't use the
     * hoverFocus mixin here because we need to target buttons that are not disabled
     */
    &:hover:not([disabled]) {
      background-color: ${(props) => props.theme.colors.grayD40};
      border-color: ${(props) => props.theme.colors.grayD40};
      color: ${(props) => props.theme.colors.white};
    }

    .svg-icon {
      display: none;
      width: 1.2rem;
      height: 1.5rem;
    }

    ${media.down('sm') `
      /**
       * Normally when a button is adjacent to another button, it gets a top margin on mobile so
       * buttons don't stick to each other. For pagination, that is not desirable. This rule counters
       * the top margin set by the base button styling
       */
      & + & {
        margin-top: 0;
      }

      /* Add right margin to all buttons but not the last. */
      :not(:last-child) {
        ${margin.right('small')}
      }

      /* Remove all buttons on mobile except prev, next and current. */
      :not(.current):not(.prev):not(.next) {
        display: none;
      }

      &.prev,
      &.next {
        position: relative;

        /* Hide the prev and next buttons text on mobile. */
        span {
          display: none;
        }

        /* Show the icon on the prev and next buttons on mobile. */
        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          display: inline-block;
          margin-left: 0;
        }
      }
    `}
  }
`;
//# sourceMappingURL=pagination.styles.js.map